import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';
import { HostService } from 'src/app/services/host.service';
import { MessageService } from 'src/app/services/message.service';
import { SocketService } from 'src/app/services/socket.service';
import { MessagesService } from './messages.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MessagesService ]
})
export class MessagesComponent implements OnInit, OnDestroy {  

  //subscription
  messageSubscription: Subscription;

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  public selectedTab:number=1;

  public messages:Array<any> = [];

  private user: any;
  constructor(private socketService: SocketService,
              private messageService: MessageService,
              public hostService: HostService) { }

  ngOnInit() {
    this.initProperty();
    this.webSocket();
  }

  initProperty() {

    this.user = JSON.parse(localStorage.getItem("user")!);

    this.messageSubscription = this.messageService.fetchAllUnreadMessagesOfUser(this.user.id).subscribe((response: any) => {

      this.messages = response.messages;

    })
  }

  private webSocket() {

    let pusher = this.socketService.initSocket();

    var channel = pusher.subscribe('channel-notification-message');
    
    channel.bind('notification-message', (response : any) => {
        
        if(response.message.status == 0) {

          if(response.message.receiver_id == this.user.id) {

            this.messages.push(response.message)
  
          }

        } else {

          let currentMessage = this.messages.filter((message: any) => message.renting_id != response.message.renting_id);

          this.messages = currentMessage;

        }
         
    });
    
  }

  openMessagesMenu() {
    this.trigger.openMenu();
    this.selectedTab = 0;
  }

  onMouseLeave(){
    this.trigger.closeMenu();
  }

  stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }

  ngOnDestroy(): void {
    
    this.messageSubscription.unsubscribe();

  }

}
